import { render, staticRenderFns } from "./cardList.vue?vue&type=template&id=fdf80e02&scoped=true&"
import script from "./cardList.vue?vue&type=script&lang=ts&"
export * from "./cardList.vue?vue&type=script&lang=ts&"
import style0 from "./cardList.vue?vue&type=style&index=0&id=fdf80e02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf80e02",
  null
  
)

export default component.exports